<template>
  <div
    style="width: 1000px;height: 500px;background-color: #2E60AF"
    @contextmenu="handleContextMenu"
  ></div>
</template>

<script>
export default {
  data() {
    return {
      menuData: [
        {
          key: "1",
          label: "列表内容1",
          children: [
            {
              key: "1-1",
              label: "目前支持body边缘检测",
              extra: "ctrl M"
            },
            {
              key: "1-2",
              label: "child2",
              disabled: true
            },
            {
              key: "1-3",
              label: "child3",
              children: [
                {
                  key: "1-3-1",
                  label: "child131child131child131child131child131child131",
                  extra: "ctrl F"
                },
                {
                  key: "1-3-2",
                  label: "chil",
                  children: [
                    {
                      key: "1-3-2-1",
                      label: "chi",
                      extra: "ctrl F"
                    },
                    {
                      key: "1-3-2-2",
                      label: "chil",
                      extra: "ctrl Z"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          key: "2",
          label: "列表内容2",
          extra: "F2"
        },
        {
          key: "3",
          label: "列表内容3列表内容3列表内容3列表内容3列表内容3",
          extra: "F3"
        },
        {
          key: "4",
          label: "列表内容4",
          disabled: true
        }
      ]
    };
  },
  methods: {
    handleSelect(...args) {
      alert(`selected: ${[...args].join(" ")}`);
    },
    handleContextMenu(ev) {
      // const instance = this.$SjContextMenu(ev, {
      //   menuData: this.menuData,
      //   onMenuSelect: ()=>{this.handleSelect();instance.destroy()},
      //   closeOnSelect: false,
      // });

      this.$SjContextMenu(ev, {
        menuData: this.menuData,
        onMenuSelect: this.handleSelect,
        selectedKey: ["2", "1-3-1"]
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
